export var dividerTheme = {
  baseStyle: {
    container: {
      display: 'flex',
      alignItems: 'center'
    },
    line: {
      flex: 1,
      backgroundColor: 'neutral.light'
    },
    text: {
      paddingLeft: 's',
      paddingRight: 's',
      color: 'neutral.darkest',
      textStyle: 'body3'
    }
  },
  variants: {
    vertical: {
      container: {
        flexDirection: 'column',
        height: '100%',
        width: 'auto'
      },
      line: {
        width: '1px'
      }
    },
    horizontal: {
      container: {
        flexDirection: 'row',
        width: '100%'
      },
      line: {
        height: '1px'
      }
    }
  },
  defaultProps: {
    variant: 'horizontal'
  }
};
//# sourceMappingURL=Divider.theme.js.map